import React from "react"

import { useTheme } from "@root/misc/theme"

export const ShowThemeViaJS: React.FC = () => {
  const {theme, ref} = useTheme()
  return <div ref={ref}>{theme} via Javascript</div>
}
